<template>
  <div>
    <PrintBase />
  </div>
</template>

<script>
import PrintBase from '@/components/DownLoadAndPrint/v1/Base.vue'

export default {
  components: { PrintBase },
}
</script>
